import {
  createContext,
  ReactElement,
  ReactNode,
  useEffect,
  useReducer,
} from "react";
import { GetApiConnection } from "../config/ConfigHelper";
import Reducer from "./Reducer";
import { GlobalStateInterface, ContextType, Toast } from "./Types";
import { toaster } from "evergreen-ui";
import { useHistory } from "react-router";
import { GetEmptyUser } from "./Generic";

const SESSION_STORE_NAME: string = "jh-nh-store";

export function GlobalStore({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const [globalState, dispatch] = useReducer(Reducer, initializeState());
  const history = useHistory();

  const CallPortalApi = (endpoint: string, options: RequestInit) => {
    return new Promise(function (resolve, reject) {
      console.log("Calling API: " + endpoint);
      fetch(GetApiConnection() + endpoint, options)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          if (response.status === 401) {
            Reroute("/login");

            var unauthToast: Toast =
              endpoint === "Authentication/Login"
                ? {
                    header: "Login Failed",
                    id: "Login-Failed",
                    description:
                      "Credentials entered are not connected to an account. Please try again.",
                    type: "warning",
                    error: "",
                  }
                : {
                    header: "Session Expired",
                    id: "Session-Expired",
                    description: "Your session has expired. Please login.",
                    type: "warning",
                    error: "",
                  };

            HandleToast(unauthToast);
          }

          throw new Error("Api responded with error status " + response.status);
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const HandleToast = (toast: Toast) => {
    // Stop any toasts if the error is unauthorised
    if (!(JSON.stringify(toast.error) || "").includes("401")) {
      if (toast.type === "success") {
        toaster.success(toast.header, {
          id: toast.id,
          description: toast.description,
        });
      }
      if (toast.type === "warning") {
        toaster.warning(toast.header, {
          id: toast.id,
          description: toast.description,
        });
      }
      if (toast.type === "danger") {
        toaster.danger(toast.header, {
          id: toast.id,
          description: toast.description,
        });
      }
    }
  };

  function Reroute(path: string) {
    history.push(path);
  }

  const globalFunctions: any = {
    CallPortalApi: CallPortalApi,
    HandleToast: HandleToast,
    Reroute: Reroute,
  };

  useEffect(() => {
    sessionStorage.setItem(SESSION_STORE_NAME, JSON.stringify(globalState));
  }, [globalState]);

  return (
    <globalContext.Provider value={{ globalState, dispatch, globalFunctions }}>
      {children}
    </globalContext.Provider>
  );
}

export const globalContext = createContext({} as ContextType);

export const initialState: GlobalStateInterface = {
  user: GetEmptyUser(),
  caseStatuses: [],
  purchaseStatuses: [],
  developments: [],
  milestoneTypes: [],
};

export function initializeState() {
  const fromSessionStorage = JSON.parse(
    sessionStorage.getItem(SESSION_STORE_NAME) as string
  );
  return fromSessionStorage || initialState;
}
